import { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';
import { HiOutlineArrowRight } from 'react-icons/hi';
import { projects } from '../data/content';
import Reveal from './Reveal';
import './Projects.css';

function ProjectCard({ project, index }) {
  const ref = useRef(null);

  // 3D tilt on pointer move.
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 200, damping: 18 });
  const sry = useSpring(ry, { stiffness: 200, damping: 18 });
  const rotateX = useTransform(srx, [-0.5, 0.5], [8, -8]);
  const rotateY = useTransform(sry, [-0.5, 0.5], [-8, 8]);

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    rx.set((e.clientY - rect.top) / rect.height - 0.5);
    ry.set((e.clientX - rect.left) / rect.width - 0.5);
  };
  const onLeave = () => {
    rx.set(0);
    ry.set(0);
  };

  return (
    <Reveal
      className={`project project--${project.accent}`}
      delay={index * 0.08}
      style={{ perspective: 1000 }}
    >
      <motion.a
        ref={ref}
        href={project.link}
        target="_blank"
        rel="noreferrer"
        className="project__card card"
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        style={{ rotateX, rotateY, transformStyle: 'preserve-3d' }}
      >
        <div className="project__glow" aria-hidden />

        <div className="project__top">
          <span className="project__num mono">0{index + 1}</span>
          <span className="project__arrow">
            <HiOutlineArrowRight />
          </span>
        </div>

        <div className="project__body" style={{ transform: 'translateZ(40px)' }}>
          <h3 className="project__title">{project.title}</h3>
          <p className="project__blurb">{project.blurb}</p>
        </div>

        <div className="project__tags">
          {project.tags.map((t) => (
            <span key={t} className="chip">{t}</span>
          ))}
        </div>
      </motion.a>
    </Reveal>
  );
}

export default function Projects() {
  return (
    <section id="projects" className="section projects">
      <div className="container">
        <Reveal className="section-head projects__head">
          <div>
            <span className="eyebrow">Selected Work</span>
            <h2 className="section-title">
              Things I've <span className="gradient-text">built</span>
            </h2>
          </div>
          <p className="section-subtitle projects__subtitle">
            A snapshot of the systems and features I've shipped across my career.
            Hover to explore.
          </p>
        </Reveal>

        <div className="projects__grid">
          {projects.map((p, i) => (
            <ProjectCard key={p.title} project={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
